module.exports = __webpack_public_path__ + "img/nvHai4.38c0985b.png";